import { useEffect, useMemo, useState } from "react";
import { getDownloadsForProduct } from "../../../../lib/utils/api";
import { Download } from "./types";

export const useDownloads = ({ code, name }: { code?: string; name?: string }) => {
  const [data, setData] = useState<Download | undefined>(undefined)
  const [error, setError] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    setError(undefined)
    setData(undefined)
      
    if (!name || !code) {
      setLoading(false)
      setError('ERROR_NO_SELECTION')
    } else {
      getDownloadsForProduct(name, code)
        .then(data => {          
          setData(data as Download)
          setLoading(false)
        })
        .catch(e => {
          setLoading(false)
          setError(e.message)
        })
    }
  }, [code, name])

  return { data, error, loading, kits: data?.kits, licenses: data?.licenses }
}